import { render, staticRenderFns } from "./resourceDialog.vue?vue&type=template&id=066246a6&"
import script from "./resourceDialog.vue?vue&type=script&lang=js&"
export * from "./resourceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports